export default {"src":"/_next/static/media/WhoWeAre_012A.83a30e4f.JPG","height":692,"width":1920};